import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ApplicantState {
  token: string | null;
  email: string | null;
  pendingEmail: string | null;
  setToken: (token: string, email: string) => void;
  setPendingEmail: (email: string) => void;
  clear: () => void;
}

export const useApplicantStore = create<ApplicantState>()(
  persist(
    (set) => ({
      token: null,
      email: null,
      pendingEmail: null,
      setToken: (token, email) => set({ token, email, pendingEmail: null }),
      setPendingEmail: (email) => set({ pendingEmail: email }),
      clear: () => set({ token: null, email: null, pendingEmail: null }),
    }),
    {
      name: 'pgs-applicant',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
